angular.module('bmsApp.config', []);
angular.module('bmsApp.config').service('ConfigService', function () {
	this.config = {
		select: {
			defaultOptionLabel: ' - Please Select - ',
			defaultOptionLabelShort: '- Select - ',
			defaultAllOptionLabel: 'All',
		},
		table: {
			params: {
				count: 25
			},
			settings: {
				counts: [10, 25,100,500]
			}
		},
		tabbedTable: {
			params: {
				count: 10
			},
			settings: {
				counts: [10, 25, 100]
			}
		},
		format: {
			date: {
				// Simple formats
				dbDateTime: 'yyyy-MM-dd HH:mm:ss', // 1969-12-31 23:59:59
				amDbDateTime: 'YYYY-MM-DD HH:mm:ss', // moment.js
				
				dbDate: 'yyyy-MM-dd', // 1969-12-31
				amDbDate: 'YYYY-MM-DD', // moment.js
				
				dbTime: 'HH:mm:ss', // 23:59:59
				amDbTime: 'HH:mm:ss', // moment.js
				// Short formats
				shortDateTime: 'dd/MM/yyyy h:mm a', // 31/12/1969 11:59 PM
				amShortDateTime: 'DD/MM/YYYY H:mm A', // moment.js
				
				shortDate: 'dd/MM/yyyy', // 31/12/1969
				amShortDate: 'DD/MM/YYYY', // moment.js

				amShortDay: 'ddd',
				
				shortTime: 'h:mm a', // 11:59 PM
				amShortTime: 'H:mm A',

				shortTime24: 'hh:mm a', // 23:59
				amShortTime24: 'HH:mm',
				// Medium formats
				mediumDate: 'EEE d MMM yyyy', // Wed 31 Dec 1969
				amMediumDate: 'ddd D MMM YYYY', // moment.js
				amMediumDate2: 'Do MMM YYYY', // moment.js - 31st Dec 1969
				amMediumDate3: 'ddd, Do MMM YYYY', // moment.js - Wed, 31st Dec 1969

				mediumDateTime: 'ddd do MMM YYYY h:mma', // Wed 31 Dec 1969 11:59am
				amMediumDateTime: 'ddd Do MMM YYYY HH:mm', // moment.js
				// Full formats
				fullDateTime: 'EEEE, dd MMMM, yyyy h:mm:ss a', // Wednesday, 31 December, 1969 11:59:59 PM
				amFullDateTime: 'dddd, Do MMMM, YYYY HH:mm:ss A', // moment.js
				
				fullDate: 'EEEE, dd MMMM, yyyy', // Wednesday, 31 December, 1969
				amFullDate: 'dddd, Do MMMM, YYYY', // moment.js
				fullDateNoYear: 'EEEE, dd MMMM', // Wednesday, 31 December, 1969
				amFullDateNoYear: 'dddd, Do MMMM', // moment.js

				naturalDate: 'MMMM dd yyyy', // December 31st 1969, 
				amNaturalDate: 'MMMM Do YYYY', // December 31st 1969
				feeDate: 'MMM YYYY'
			}
		},
		datePicker: {
			timeOnly: {
				'options': {
					timePicker: true,
					timePickerIncrement: 5,
				}
			},
			basic: {
				storageFormat: 'YYYY-MM-DD',
				'options': {
					format: 'Do MMMM YYYY',
					singleDatePicker: true,
					showDropdowns: true,
					showWeekNumbers: true,
					opens: 'right',
					drops: 'down',
					parentEl: '#work-container .content-scroll'
				},
				'eventHandlers': {}
			},
			range: {
				storageFormat: 'YYYY-MM-DD',
				'options': {
					format: 'Do MMMM YYYY',
					showDropdowns: false,
					showWeekNumbers: true,
					ranges: {
						'Today': [moment(), moment()],
						'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
						'Last 7 Days': [moment().subtract(6, 'days'), moment()],
						'Last 30 Days': [moment().subtract(29, 'days'), moment()],
						'This Month': [moment().startOf('month'), moment().endOf('month')],
						'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
						'Last 3 Months': [moment().subtract(3, 'month').endOf('month'), moment()],
						'Last Year': [moment().subtract(12, 'month').endOf('month'), moment()]
					},
					opens: 'right',
					drops: 'down',
					separator: ' - ',
					parentEl: '#work-container .content-scroll'
				},
				'eventHandlers': {}
			},
			monthRange: {
				storageFormat: 'YYYY-MM-DD',
				'options': {
					format: 'MMMM YYYY',
					showDropdowns: false,
					showWeekNumbers: true,
					ranges: {
						// 'Today': [moment(), moment()],
						// 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
						// 'Last 7 Days': [moment().subtract(6, 'days'), moment()],
						// 'Last 30 Days': [moment().subtract(29, 'days'), moment()],
						'This Month': [moment().startOf('month'), moment().endOf('month')],
						// 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
						'Last 3 Months': [moment().subtract(3, 'month').endOf('month'), moment()],
						'Last Year': [moment().subtract(12, 'month').endOf('month'), moment()]
					},
					opens: 'right',
					drops: 'down',
					separator: ' - ',
					parentEl: '#work-container .content-scroll'
				},
				'eventHandlers': {}
			}
		},
		timePicker: {
			basic: {
				'options': {
					show24Hours: true,
					spinnerImage: ''
				}
			}
		},
		uiTimepickerOptions: {
			step: 5,
			timeFormat: 'G:i',
			asMoment: true,
			minTime: '09:00',
			appendTo: '.content-scroll'
		},
		timedAttendanceStatuses: {
			mm: [
				0,
				5, // Authorized Leave - Half Day
				7, // Unpaid Unauthorised Leave - Half Day
				6 // Paid Unauthorised Leave - Half Day
			],
			tg: [
				0
			]
		}
	};
});
